<template>
  <div class="meunHeader avatar" v-click-outside="closeMenu">
    <span @click="toggleMenu" class="icon-wrapper">
      <span
        class="welcome"
        v-if="isAuthenticated" >
        {{ $t('header.welcome', 'Welcome back') }}, {{ personalDetail.firstName }}
      </span>
      <app-icon name="avatar"/>
      <span
        class="avatar-bubble_notification bubble-notification"
        v-if="hasOpenBalance"
      >
        !
      </span>
    </span>
    <transition name="fade" mode="out-in">
      <div class="menuWrapper" v-show="showMenu">
        <ul class="menuBody">
          <li v-if="!isAuthenticated">
            <a
              href="##"
              @click.prevent="redirectToLoginPage"
              data-name="menuItem-login"
            >
              {{ $t('header.menu.link.logIn', 'Log In') }}
            </a>
          </li>

          <template v-if="isAuthenticated">
            <li class="list-notification" v-if="showBillingLink">
              <span class="bubble-notification">!</span>
              <router-link
                :to="{
                  name: 'billing',
                  query: {
                    language: queryLanguage
                  }
                }"
                data-name="menuItem-invioces"
              >
                {{ $t('header.menu.link.invoice', 'Invoice') }}
              </router-link>
            </li>
            <li>
              <router-link
                :to="$route.meta.myAccountSubPage ? { path: $route.path, query: {
                  language: queryLanguage
                } } : { path: '/my-account', query: {
                  language: queryLanguage
                }}"
                data-name="menuItem-myAccount"
              >
                {{ $t('header.menu.link.myAccount', 'My Account') }}
              </router-link>
            </li>
            <li @click.prevent="logOut">
              <a href="##" data-name="menuItem-logOut">{{ $t('header.menu.link.logOut', 'Log Out') }}</a>
            </li>
          </template>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { detectedCulture } from '@/utilities/common/culture'
  import { pick } from 'lodash'

  export default {
    name: 'app-header-menu',

    data () {
      return {
        showMenu: false,
        canadaLanguage: window.localStorage.getItem('canadaLanguage'),
        belgiumLanguage: window.localStorage.getItem('belgiumLanguage')
      }
    },

    computed: {
      ...mapGetters('account', ['isAuthenticated', 'hasOpenBalance']),
      ...mapState('account', {
        personalDetail: state => state.profile.personalDetail
      }),
      showBillingLink () {
        return this.hasOpenBalance
      },
       isCanadaSite () {
         if (!this.belgiumLanguage) {
            return detectedCulture.code === 'en-ca' 
         }
      },
       isBelgiumSite () {
         if (!this.canadaLanguage) {
        return detectedCulture.code === 'nl-be'
         }
      },

      queryLanguage () {
        if (this.isCanadaSite) {
          if (this.canadaLanguage) {
            return this.canadaLanguage
          } else {
            return 'en-CA'
          }
        }

         if (this.isBelgiumSite) {
          if (this.belgiumLanguage) {
            return this.belgiumLanguage
          } else {
            return 'nl-BE'
          }
        }
      },

      


      getBunldeFromQuery () {
        return this.$route.query.bundle
      }
    },

    methods: {
      toggleMenu () {
        this.showMenu = !this.showMenu
      },

      closeMenu () {
        this.showMenu = false
      },

      async logOut () {
        this.$store.dispatch('account/logout')
        this.closeMenu()
        await this.$udiAuth.logout()
      },

      redirectToLoginPage () {
        this.trackConversion({ name: 'user_login' })
        if (this.$route.name === 'checkout') {
          this.$udiAuth.login({ returnUrl: this.$route.fullPath })
        } else {
          this.$udiAuth.login()
        }
      }
    },

    watch: {
      '$route': function () {
        this.closeMenu()
      },

      'isAuthenticated': {
        handler (newVal) {
          if (newVal) {
            this.$store.dispatch('account/fetchBillingInvoices').catch((error) => {
              console.error(error)
            })
          }
        },
        immediate: true
      }
    },

    created () {
       if (this.isCanadaSite && this.$route.name !== 'payment-result') {
        if (!this.$route.query.language) {
          if (this.canadaLanguage && this.canadaLanguage !== 'undefined') {
            if (this.$route.name !== 'cart' || this.$route.name !== 'checkout') {
              this.$router.push({
                query: {
                  language: this.canadaLanguage
                }
              })
            } else if (this.$route.name === 'cart') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.canadaLanguage })
              this.$router.push({
                name: 'cart',
                query: routeQuery
              })
            } else if (this.$route.name === 'checkout') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.canadaLanguage })
              this.$router.push({
                name: 'checkout',
                query: routeQuery
              })
            }
            window.localStorage.setItem('canadaLanguage', this.canadaLanguage)
          } 
          else {
            if (this.$route.name !== 'cart' || this.$route.name !== 'checkout') {
              this.$router.push({
                query: {
                  language: 'en-CA'
                }
              })
            } else if (this.$route.name === 'cart') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'en-CA' })
              this.$router.push({
                name: 'cart',
                query: routeQuery
              })
            } else if (this.$route.name === 'checkout') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'en-CA' })
              this.$router.push({
                name: 'checkout',
                query: routeQuery
              })
            }
          }
          window.localStorage.setItem('canadaLanguage', this.$route.query.language)
        } else {
          if (this.$route.name === 'cart') {
            const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.$route.query.language })
            this.$router.push({
              name: 'cart',
              query: routeQuery
            })
          } else if (this.$route.name === 'checkout') {
            const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.$route.query.language })
            this.$router.push({
              name: 'checkout',
              query: routeQuery
            })
          } else {
            this.$router.push({
              query: {
                language: this.canadaLanguage
              }
            })
          }
          window.localStorage.setItem('canadaLanguage', this.$route.query.language)
          
        }
      }

       if (this.isBelgiumSite && this.$route.name !== 'payment-result') {
        if (!this.$route.query.language) {
          if (this.belgiumLanguage && this.belgiumLanguage !== 'undefined') {
            if (this.$route.name !== 'cart' || this.$route.name !== 'checkout') {
              this.$router.push({
                query: {
                  language: this.belgiumLanguage
                }
              })
            } else if (this.$route.name === 'cart') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.canadaLanguage })
              this.$router.push({
                name: 'cart',
                query: routeQuery
              })
            } else if (this.$route.name === 'checkout') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.canadaLanguage })
              this.$router.push({
                name: 'checkout',
                query: routeQuery
              })
            }
            window.localStorage.setItem('belgiumLanguage', this.belgiumLanguage)
          } 
          else {
            if (this.$route.name !== 'cart' || this.$route.name !== 'checkout') {
              this.$router.push({
                query: {
                  language: 'en-CA'
                }
              })
            } else if (this.$route.name === 'cart') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'en-CA' })
              this.$router.push({
                name: 'cart',
                query: routeQuery
              })
            } else if (this.$route.name === 'checkout') {
              const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: 'en-CA' })
              this.$router.push({
                name: 'checkout',
                query: routeQuery
              })
            }
          }
          window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
        } else {
          if (this.$route.name === 'cart') {
            const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.$route.query.language })
            this.$router.push({
              name: 'cart',
              query: routeQuery
            })
          } else if (this.$route.name === 'checkout') {
            const routeQuery = Object.assign({}, pick(this.$route.query, ['modified', 'coupon']), { bundle: this.getBunldeFromQuery, language: this.$route.query.language })
            this.$router.push({
              name: 'checkout',
              query: routeQuery
            })
          } else {
            this.$router.push({
              query: {
                language: this.belgiumLanguage
              }
            })
          }
          window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
          
        }
      }
    }
  }
</script>

<style lang="scss">
  .meunHeader {
    .icon-wrapper {
      cursor: pointer;
      align-items: center;
      display: inline-flex;
      position: relative;
    }

    .welcome {
      color: #fff;
      margin-right: .1rem;
    }

    .avatar-bubble_notification {
      position: absolute;
      right: -.07rem;
      top: -.05rem;
    }
  }

  .menuWrapper {
    background: $blue;
    position: absolute;
    right: .08rem;
    padding: .1rem .2rem;
    border-radius: .08rem;
    top: .62rem;
    left: auto;

    &::before {
      position: absolute;
      display: block;
      content: '';
      height: 0;
      width: 0;
      border: solid transparent;
      border-width: 0 .18rem .14rem;
      border-bottom-color: $blue;
      top: -.13rem;
      right: .33rem;
    }

    .menuBody {
      li {
        text-align: right;
        font-size: .16rem;
        font-weight: bold;

        + li {
          padding-top: .08rem;
        }

        a {
          color: $white;
          padding: .08rem 0;

          &.router-link-exact-active {
            border-bottom: solid .02rem white;
            cursor: default;
          }
        }
      }

      .list-notification {
        display: flex;
        justify-content: space-between;
        align-content: space-between;
        align-items: center;

        .bubble-notification {
          margin-right: .15rem;
        }
      }
    }
  }
</style>
